import React, { Fragment } from 'react';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
interface ProgressIndicatorProps {
  currentStep: number;
}
export function ProgressIndicator({
  currentStep
}: ProgressIndicatorProps) {
  const steps = [{
    number: 1,
    label: 'Payment'
  }, {
    number: 2,
    label: 'Signature'
  }, {
    number: 3,
    label: 'Appointment'
  }];
  return <div className="flex items-center justify-center gap-2 px-6 py-4" data-id="element-40">
      {steps.map((step, index) => {
      const isCompleted = currentStep > step.number;
      const isCurrent = currentStep === step.number;
      const isUpcoming = currentStep < step.number;
      return <Fragment key={step.number} data-id="element-41">
            <div className="flex flex-col items-center gap-1 relative z-10" data-id="element-42">
              <motion.div initial={false} animate={{
            backgroundColor: isCompleted || isCurrent ? '#0F4C3A' : '#D1D5DB',
            color: isCompleted || isCurrent ? '#FFFFFF' : '#4B5563',
            scale: isCurrent ? 1.1 : 1
          }} transition={{
            duration: 0.3,
            ease: [0.22, 1, 0.36, 1]
          }} className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold shadow-sm" data-id="element-43">
                {isCompleted ? <motion.div initial={{
              scale: 0,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 20
            }} data-id="element-44">
                    <Check className="w-4 h-4" strokeWidth={3} data-id="element-45" />
                  </motion.div> : step.number}
              </motion.div>
              <span className={`text-xs transition-colors duration-300 ${isCurrent || isCompleted ? 'text-gray-900 font-medium' : 'text-gray-500'}`} data-id="element-46">
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && <div className="w-12 h-0.5 mb-5 bg-gray-300 relative overflow-hidden rounded-full" data-id="element-47">
                <motion.div className="absolute inset-0 bg-[#0F4C3A] origin-left" initial={false} animate={{
            scaleX: currentStep > step.number ? 1 : 0
          }} transition={{
            duration: 0.4,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-48" />
              </div>}
          </Fragment>;
    })}
    </div>;
}